export interface BuildInfo {
  tag: string;
  commit: string;
  builtAt: string;
}

declare const __APP_BUILD_INFO__: BuildInfo | undefined;

export const BUILD_INFO: BuildInfo =
  typeof __APP_BUILD_INFO__ !== 'undefined'
    ? __APP_BUILD_INFO__
    : {
        tag: 'dev',
        commit: 'local',
        builtAt: new Date().toISOString(),
      };
